<template>
  <div class="slider-banner product-bg">
    <swiper 
      ref="goodSwiper"
      class="swiper-wrapper"
      :options="ProductConSwiper"
      v-if="imgUrls.length > 0"
    >
      <swiperSlide
        class="swiper-slide"
        v-for="item in imgUrls"
        :key="item"
      >
        <img :src="item" class="slide-image" />
      </swiperSlide>
    </swiper>
    <div class="pages">{{ currents || 1 }}/{{ imgUrls.length || 1 }}</div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "@assets/css/swiper.min.css";
export default {
  name: "ProductConSwiper",
  components: {
    swiper,
    swiperSlide
  },
  props: {
    imgUrls: {
      type: Array,
      default: () => []
    }
  },
  data: function() {
    let that = this;
    return {
      update: true,
      currents: 1,
      ProductConSwiper: {
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true,
        on: {
          slideChangeTransitionStart: function() {
            that.currents = this.realIndex + 1;
          }
        }
      }
    };
  },
  watch: {
    imgUrls:function(val,oldval)
    {
      if(oldval != "")
      {
        this.$refs.goodSwiper.swiper.removeAllSlides();
        if(val.length>0)
        {
          let len = val.length;
          for (let index = 0; index < len; index++) {
            this.$refs.goodSwiper.swiper.addSlide(index+1,'<div class="swiper-slide"><img src="'+val[index]+'" class="slide-image" /></div>');
          }
          this.currents=1;
          this.$refs.goodSwiper.swiper.update();
          this.$refs.goodSwiper.swiper.slideToLoop(0, 1000, false);
        }
      }
    }
  },
  computed: {
    
  },
  mounted: function() {
    
  },
  methods: {
    
  }
};
</script>
